export function useWeatherAnimation() {
  function initializeWeatherAnimation() {
    const canvas = document.getElementById("weather-canvas");
    if (!canvas) return () => {};

    const ctx = canvas.getContext("2d");
    const container = canvas.parentElement;

    const resizeCanvas = () => {
      canvas.width = container.offsetWidth;
      canvas.height = container.offsetHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    class Particle {
      constructor(x, y, vx, vy, type = "rain") {
        this.x = x;
        this.y = y;
        this.vx = vx;
        this.vy = vy;
        this.type = type;
        this.life = 1;
        this.decay = Math.random() * 0.005 + 0.002;
        this.size =
          type === "rain" ? Math.random() * 2 + 1 : Math.random() * 3 + 2;
        this.wind = (Math.random() - 0.5) * 2;
      }

      update() {
        this.x += this.vx + this.wind;
        this.y += this.vy;
        this.life -= this.decay;
        this.wind *= 0.98;
      }

      draw(ctx) {
        ctx.save();
        ctx.globalAlpha = this.life * 0.7;

        if (this.type === "rain") {
          ctx.strokeStyle = `rgba(200, 220, 255, ${this.life * 0.8})`;
          ctx.lineWidth = this.size;
          ctx.lineCap = "round";
          ctx.beginPath();
          ctx.moveTo(this.x, this.y);
          ctx.lineTo(this.x - this.vx * 4, this.y - this.vy * 4);
          ctx.stroke();
        } else if (this.type === "wind") {
          ctx.strokeStyle = `rgba(100, 150, 255, ${this.life * 0.3})`;
          ctx.lineWidth = 1.5;
          ctx.beginPath();
          ctx.moveTo(this.x, this.y);
          ctx.lineTo(this.x + this.vx * 6, this.y + this.vy * 4);
          ctx.stroke();
        } else if (this.type === "storm") {
          ctx.fillStyle = `rgba(139, 69, 19, ${this.life * 0.4})`;
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size * 0.5, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();
      }
    }

    let particles = [];
    let stormIntensity = 0;
    let stormDirection = 1;
    let animationFrameId = null;
    let isDisposed = false;

    const animate = () => {
      if (isDisposed) return;

      // Clear canvas with semi-transparent background
      ctx.fillStyle = "rgba(35, 56, 69, 0.08)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Update storm intensity
      stormIntensity += 0.001 * stormDirection;
      if (stormIntensity > 0.8) stormDirection = -1;
      if (stormIntensity < 0.2) stormDirection = 1;

      // Create rain particles - more consistently
      const rainProbability = 0.8; // 80% chance per frame
      if (Math.random() < rainProbability) {
        const x = Math.random() * canvas.width;
        const y = -20;
        const windForce = (Math.random() - 0.5) * 2 * stormIntensity;
        const rainVelocity = Math.random() * 3 + 3 + stormIntensity * 2;

        particles.push(
          new Particle(x, y, windForce, rainVelocity, "rain")
        );
      }

      // Create wind particles occasionally
      if (Math.random() > 0.95) {
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height;
        const windForce = (Math.random() - 0.5) * 3;

        particles.push(
          new Particle(x, y, windForce, Math.random() * 1 - 0.5, "wind")
        );
      }

      // Create storm particles occasionally
      if (Math.random() > 0.92) {
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height * 0.6;

        particles.push(
          new Particle(
            x,
            y,
            (Math.random() - 0.5) * 2,
            (Math.random() - 0.5) * 2,
            "storm"
          )
        );
      }

      // Update and draw particles
      particles = particles.filter((p) => p.life > 0 && p.y < canvas.height);

      particles.forEach((p) => {
        p.update();
        p.draw(ctx);
      });

      // Lightning flashes
      if (Math.random() > 0.98) {
        const flashIntensity = Math.random() * 0.15;
        ctx.fillStyle = `rgba(200, 220, 255, ${flashIntensity})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      // Horizontal wind streaks
      if (Math.random() > 0.92) {
        ctx.strokeStyle = `rgba(100, 150, 255, ${0.05 * stormIntensity})`;
        ctx.lineWidth = 1;
        ctx.beginPath();
        const yPos = Math.random() * canvas.height;
        ctx.moveTo(0, yPos);
        ctx.lineTo(canvas.width, yPos - Math.random() * 50);
        ctx.stroke();
      }

      animationFrameId = requestAnimationFrame(animate);
      canvas.__animationFrameId = animationFrameId;
    };

    animate();

    return () => {
      isDisposed = true;
      window.removeEventListener("resize", resizeCanvas);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      canvas.__animationFrameId = null;
      particles = [];
    };
  }

  return {
    initializeWeatherAnimation,
  };
}